import React from "react"
import { Logo } from "@/components/Primitives"
import { cn } from "@/lib/utils/utils"

interface AuthLogoProps {
  className?: string
}

export function AuthLogo({ className = "" }: AuthLogoProps) {
  return (
    <div className={cn("hidden md:block w-full px-4 py-6", className)}>
      <Logo variant="white" width={170} />
    </div>
  )
}
